import moment from 'moment';
const translations = require('../assets/translations/translations.json');

export const __ = (term: string) => {
    if (translations[term]) {
        return translations[term];
    }

    return term;
};

export const capitalize = (term: string) => {
    if (term.length === 0) {
        return term;
    }

    return term.charAt(0).toUpperCase() + term.slice(1);
};

export const formatDate = (date: string, format = 'DD.MM.YYYY HH:mm:ss') => {
    if (date && date !== '0000-00-00 00:00:00') {
        return moment(date).format(format);
    }

    return null;
};
